// ##### Komarov 2025-07-22
import React from 'react';
// ##### 25-05-21 Komarov
import { useSelector } from 'react-redux';
import SeoLogoIco from '../../../Library/SEO/SeoLogoIco';
import SeoMetaDescription from '../../../Library/SEO/SeoMetaDescription';
import SeoMetaKeywords from '../../../Library/SEO/SeoMetaKeywords';
import SeoMetaTitle from '../../../Library/SEO/SeoMetaTitle';
import Search from '../../FirstPageofSearchModule/SearchResizersAndSwitchers/Search';
import RouteSwitcher from '../../RoutesAndLinks/RouteSwitcher';
import HeaderClassDiv from './HeaderClassDiv';

// ##### Komarov 2025-07-22
const HeaderWrapperMain = () => {
  const whitelabel = useSelector(state => state.whitelabel);
  const currentUrl = useSelector(state => state.currentUrl);
  const company_cipher = useSelector(state => state.whitelabel.company_cipher);
  const isMainPage =
    whitelabel.set &&
    company_cipher.length + currentUrl.indexOf(company_cipher) ===
    currentUrl.length;

  // ##### 23-09-21 Komarov
  return (
    <header
      data-component="HeaderWrapperMain"
      className="wrapperMain"
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <SeoLogoIco />
      <SeoMetaTitle />
      <SeoMetaKeywords />
      <SeoMetaDescription />
      <HeaderClassDiv headerClass="WhiteLabelTopMenu" />
      {/* ##### 24-03-01 Komarov */}
      {isMainPage && <Search style={{ order: '2' }} />}
      {/* ##### 24-03-01 Komarov */}
      <RouteSwitcher />
    </header>
  );
};

export default HeaderWrapperMain;
